// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import '../Auth.css';
// import HRMSImage from '../assets/hrms.jpg';
// import logo from '../assets/coreopsai.png';
// import { backend_url } from '../config';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   faEnvelope,
//   faLock,
//   faEye,
//   faEyeSlash,
//   faSignInAlt,
//   faExclamationTriangle,
//   faUserPlus,
//   faQuestionCircle,
//   faRocket,
//   faUserTie,
//   faChartLine,
// } from '@fortawesome/free-solid-svg-icons';

// function SignIn({ setIsLoggedIn }) {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setError('');
//     setIsLoading(true);

//     try {
//       const response = await axios.post(`${backend_url}/login`, {
//         email,
//         password,
//       });

//       if (response.status === 200) {
//         // Add success animation before redirect
//         setTimeout(() => {
//           // Set the logged in state
//           setIsLoggedIn(true);
//           // Note: App.js now handles storing this in localStorage
//           navigate('/upload');
//         }, 800);
//       } else {
//         setError(
//           response.data.message || 'Invalid credentials. Please try again.'
//         );
//         setIsLoading(false);
//       }
//     } catch (err) {
//       console.error('SignIn Error:', err);
//       setError('Invalid credentials or server error. Please try again.');
//       setIsLoading(false);
//     }
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   return (
//     <div className='signin-page-container'>
//       <div
//         className='content-side'
//         style={{
//           backgroundImage: `url(${HRMSImage})`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           position: 'relative',
//         }}
//       >
//         {/* Overlay to ensure text is readable against the background image */}
//         <div
//           style={{
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: 'rgba(0, 0, 0, 0.6)',
//             zIndex: 1,
//           }}
//         ></div>

//         {/* Content wrapper with higher z-index to appear above the overlay */}
//         <div style={{ position: 'relative', zIndex: 2, height: '100%' }}>
//           <div className='brand-section'>
//             {/* <img src={logo} alt="CoreHR" className="logo-image-large" /> */}
//             <h1 className='brand-tagline' style={{ color: '#fff' }}>
//               Making recruiting easy and 2x faster
//             </h1>
//           </div>

//           <div className='feature-cards'>
//             <div
//               className='feature-card'
//               style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}
//             >
//               <div className='feature-icon-container'>
//                 <FontAwesomeIcon icon={faRocket} className='feature-icon' />
//               </div>
//               <h3>Accelerate Your Hiring</h3>
//               <p>
//                 Cut your hiring time in half with AI-powered candidate matching
//                 and advanced resume parsing
//               </p>
//             </div>

//             <div
//               className='feature-card'
//               style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}
//             >
//               <div className='feature-icon-container'>
//                 <FontAwesomeIcon icon={faUserTie} className='feature-icon' />
//               </div>
//               <h3>Find Better Talent</h3>
//               <p>
//                 Identify the most qualified candidates with precision scoring
//                 and intelligent ranking
//               </p>
//             </div>

//             <div
//               className='feature-card'
//               style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}
//             >
//               <div className='feature-icon-container'>
//                 <FontAwesomeIcon icon={faChartLine} className='feature-icon' />
//               </div>
//               <h3>Data-Driven Decisions</h3>
//               <p>
//                 Make smarter hiring choices with comprehensive analytics and
//                 detailed candidate insights
//               </p>
//             </div>
//           </div>

//           <div
//             className='testimonial'
//             style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}
//           >
//             <p>
//               "COREHire transformed our recruitment process, saving us countless
//               hours and helping us find exceptional talent."
//             </p>
//             {/* <div className="testimonial-author">
//               <div className="author-initial">A,M</div>
//               <div className="author-info">
//                 <strong>Aditya & Mansih</strong>
//                 <span>Developers of this product</span>
//               </div>
//             </div> */}
//           </div>
//         </div>
//       </div>

//       <div className='auth-container'>
//         <div className='auth-card'>
//           <div className='auth-header'>
//             <img src={logo} alt='CoreHR' className='logo-image' />
//             <h2 className='auth-title'>Sign In</h2>
//           </div>

//           {error && (
//             <div className='error-message'>
//               <FontAwesomeIcon icon={faExclamationTriangle} />
//               <span>{error}</span>
//             </div>
//           )}

//           <form onSubmit={handleSubmit} className='auth-form'>
//             <div className='form-group'>
//               <div className='input-icon-wrapper'>
//                 <FontAwesomeIcon icon={faEnvelope} className='input-icon' />
//                 <input
//                   type='email'
//                   id='email'
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   placeholder='Email Address'
//                   required
//                   className='icon-input'
//                 />
//               </div>
//             </div>

//             <div className='form-group'>
//               <div className='input-icon-wrapper'>
//                 <FontAwesomeIcon icon={faLock} className='input-icon' />
//                 <input
//                   type={showPassword ? 'text' : 'password'}
//                   id='password'
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder='Password'
//                   required
//                   className='icon-input'
//                 />
//                 <button
//                   type='button'
//                   className='toggle-password'
//                   onClick={togglePasswordVisibility}
//                   aria-label={showPassword ? 'Hide password' : 'Show password'}
//                 >
//                   <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
//                 </button>
//               </div>
//             </div>

//             <div className='form-footer'>
//               <Link to='/forgotpassword' className='forgot-password'>
//                 <FontAwesomeIcon icon={faQuestionCircle} /> Forgot Password?
//               </Link>
//             </div>

//             <button
//               type='submit'
//               className={`submit-button ${isLoading ? 'loading' : ''}`}
//               disabled={isLoading}
//             >
//               {isLoading ? (
//                 <div className='spinner'></div>
//               ) : (
//                 <>
//                   <FontAwesomeIcon icon={faSignInAlt} /> Sign In
//                 </>
//               )}
//             </button>
//           </form>

//           <div className='auth-footer'>
//             <p>Don't have an account?</p>
//             <Link to='/signup' className='signup-link'>
//               <FontAwesomeIcon icon={faUserPlus} /> Create Account
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default SignIn;


///////////////////////////////

// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import logo from '../assets/coreopsai.png';
// import { backend_url } from '../config';

// /* ------------------------------------------------------------------ */
// /*  Inline SVG icons — no FontAwesome dependency needed                */
// /* ------------------------------------------------------------------ */
// const Icon = {
//   mail: (
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//       <rect x="3" y="5" width="18" height="14" rx="2" />
//       <path d="m3 7 9 6 9-6" />
//     </svg>
//   ),
//   lock: (
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//       <rect x="4" y="11" width="16" height="10" rx="2" />
//       <path d="M8 11V7a4 4 0 0 1 8 0v4" />
//     </svg>
//   ),
//   eye: (
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//       <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
//       <circle cx="12" cy="12" r="3" />
//     </svg>
//   ),
//   eyeOff: (
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//       <path d="M3 3l18 18" />
//       <path d="M10.6 5.1A10.8 10.8 0 0 1 12 5c6.5 0 10 7 10 7a17.5 17.5 0 0 1-3.2 4M6.1 6.1A17 17 0 0 0 2 12s3.5 7 10 7a10.4 10.4 0 0 0 4-.8" />
//       <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
//     </svg>
//   ),
//   alert: (
//     <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//       <path d="M12 9v4M12 17h.01" />
//       <path d="M10.3 3.9 1.8 18.1A2 2 0 0 0 3.5 21h17a2 2 0 0 0 1.7-2.9L13.7 3.9a2 2 0 0 0-3.4 0Z" />
//     </svg>
//   ),
//   arrow: (
//     <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//       <path d="M5 12h14M13 6l6 6-6 6" />
//     </svg>
//   ),
// };

// /* ------------------------------------------------------------------ */
// /*  Candidate stack data (left-panel visual)                           */
// /* ------------------------------------------------------------------ */
// const CANDIDATES = [
//   { initials: 'PS', name: 'Priya Sharma', role: 'Senior Backend Engineer', score: 94, tags: ['Java', 'Spring Boot', '6 yrs'] },
//   { initials: 'RK', name: 'Rahul Kapoor', role: 'Full-Stack Developer', score: 87, tags: ['React', 'Node.js', '4 yrs'] },
//   { initials: 'AN', name: 'Ananya Nair', role: 'Data Engineer', score: 81, tags: ['Python', 'SQL', '5 yrs'] },
// ];

// function SignIn({ setIsLoggedIn }) {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState('');
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setError('');
//     setIsLoading(true);

//     try {
//       const response = await axios.post(`${backend_url}/login`, { email, password });

//       if (response.status === 200) {
//         setTimeout(() => {
//           setIsLoggedIn(true);
//           navigate('/upload');
//         }, 800);
//       } else {
//         setError(response.data.message || 'That email and password don\u2019t match. Try again.');
//         setIsLoading(false);
//       }
//     } catch (err) {
//       console.error('SignIn Error:', err);
//       setError('That email and password don\u2019t match. Try again.');
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="ch-root">
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Inter:wght@400;500;600&display=swap');

//         .ch-root {
//           --ink: #0b1220;
//           --ink-2: #131f36;
//           --line: rgba(255, 255, 255, 0.08);
//           --paper: #f6f7f9;
//           --card: #ffffff;
//           --text: #172033;
//           --muted: #64748b;
//           --accent: #4c5fff;
//           --accent-soft: rgba(76, 95, 255, 0.1);
//           --match: #21c07a;
//           --danger: #d84545;
//           --radius: 14px;

//           min-height: 100vh;
//           display: grid;
//           grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
//           font-family: 'Inter', system-ui, sans-serif;
//           background: var(--paper);
//           color: var(--text);
//         }

//         /* ============ LEFT: product panel ============ */
//         .ch-panel {
//           position: relative;
//           background:
//             radial-gradient(900px 500px at 85% -10%, rgba(76, 95, 255, 0.22), transparent 60%),
//             radial-gradient(700px 600px at -10% 110%, rgba(33, 192, 122, 0.10), transparent 55%),
//             var(--ink);
//           color: #eef1f7;
//           padding: 48px 56px;
//           display: flex;
//           flex-direction: column;
//           overflow: hidden;
//         }
//         .ch-panel::after {
//           content: '';
//           position: absolute;
//           inset: 0;
//           background-image: linear-gradient(var(--line) 1px, transparent 1px),
//             linear-gradient(90deg, var(--line) 1px, transparent 1px);
//           background-size: 56px 56px;
//           mask-image: radial-gradient(700px 700px at 30% 30%, #000 0%, transparent 75%);
//           pointer-events: none;
//         }
//         .ch-panel > * { position: relative; z-index: 1; }

//         .ch-wordmark {
//           font-family: 'Space Grotesk', sans-serif;
//           font-weight: 700;
//           font-size: 20px;
//           letter-spacing: 0.02em;
//           display: flex;
//           align-items: center;
//           gap: 10px;
//         }
//         .ch-wordmark .dot { color: var(--match); }

//         .ch-headline {
//           margin: 56px 0 0;
//           font-family: 'Space Grotesk', sans-serif;
//           font-size: clamp(30px, 3.2vw, 44px);
//           line-height: 1.12;
//           font-weight: 600;
//           letter-spacing: -0.02em;
//           max-width: 15ch;
//         }
//         .ch-headline em {
//           font-style: normal;
//           color: var(--match);
//         }
//         .ch-sub {
//           margin: 18px 0 0;
//           font-size: 15.5px;
//           line-height: 1.6;
//           color: #a6b0c3;
//           max-width: 42ch;
//         }

//         /* ---- candidate stack (signature element) ---- */
//         .ch-stack {
//           margin-top: 44px;
//           display: grid;
//           gap: 12px;
//           max-width: 460px;
//         }
//         .ch-card {
//           background: rgba(255, 255, 255, 0.05);
//           border: 1px solid rgba(255, 255, 255, 0.09);
//           border-radius: 12px;
//           padding: 14px 16px;
//           display: grid;
//           grid-template-columns: 40px 1fr auto;
//           gap: 14px;
//           align-items: center;
//           backdrop-filter: blur(6px);
//           animation: ch-rise 0.7s cubic-bezier(0.2, 0.7, 0.2, 1) both;
//         }
//         .ch-card:nth-child(1) { animation-delay: 0.15s; }
//         .ch-card:nth-child(2) { animation-delay: 0.3s; transform-origin: left; scale: 0.985; opacity: 0.92; }
//         .ch-card:nth-child(3) { animation-delay: 0.45s; scale: 0.97; opacity: 0.82; }

//         .ch-avatar {
//           width: 40px; height: 40px;
//           border-radius: 10px;
//           display: grid; place-items: center;
//           font-family: 'Space Grotesk', sans-serif;
//           font-weight: 600; font-size: 13px;
//           background: var(--accent-soft);
//           color: #9fb0ff;
//           border: 1px solid rgba(76, 95, 255, 0.35);
//         }
//         .ch-card-name { font-weight: 600; font-size: 14px; }
//         .ch-card-role { font-size: 12.5px; color: #8e99ad; margin-top: 2px; }
//         .ch-tags { display: flex; gap: 6px; margin-top: 8px; flex-wrap: wrap; }
//         .ch-tag {
//           font-size: 10.5px;
//           padding: 2px 8px;
//           border-radius: 999px;
//           background: rgba(255, 255, 255, 0.06);
//           border: 1px solid rgba(255, 255, 255, 0.1);
//           color: #aeb8ca;
//         }

//         .ch-score { text-align: right; }
//         .ch-score-num {
//           font-family: 'Space Grotesk', sans-serif;
//           font-weight: 700;
//           font-size: 18px;
//           color: var(--match);
//         }
//         .ch-score-label {
//           font-size: 10px;
//           letter-spacing: 0.12em;
//           text-transform: uppercase;
//           color: #7d8798;
//         }
//         .ch-meter {
//           margin-top: 6px;
//           width: 84px; height: 4px;
//           border-radius: 999px;
//           background: rgba(255, 255, 255, 0.1);
//           overflow: hidden;
//         }
//         .ch-meter i {
//           display: block; height: 100%;
//           border-radius: inherit;
//           background: linear-gradient(90deg, var(--accent), var(--match));
//           transform-origin: left;
//           animation: ch-fill 1.1s 0.5s cubic-bezier(0.2, 0.7, 0.2, 1) both;
//         }

//         .ch-panel-foot {
//           margin-top: auto;
//           padding-top: 40px;
//           display: flex;
//           gap: 28px;
//           font-size: 13px;
//           color: #8e99ad;
//         }
//         .ch-panel-foot strong {
//           display: block;
//           font-family: 'Space Grotesk', sans-serif;
//           font-size: 17px;
//           color: #eef1f7;
//           font-weight: 600;
//           margin-bottom: 2px;
//         }

//         @keyframes ch-rise {
//           from { opacity: 0; translate: 0 16px; }
//           to { opacity: inherit; translate: 0 0; }
//         }
//         @keyframes ch-fill {
//           from { transform: scaleX(0); }
//           to { transform: scaleX(var(--fill, 1)); }
//         }

//         /* ============ RIGHT: auth side ============ */
//         .ch-auth {
//           display: grid;
//           place-items: center;
//           padding: 48px 24px;
//         }
//         .ch-auth-card {
//           width: min(400px, 100%);
//         }
//         .ch-logo { height: 40px; width: auto; margin-bottom: 28px; }
//         .ch-title {
//           font-family: 'Space Grotesk', sans-serif;
//           font-size: 26px;
//           font-weight: 600;
//           letter-spacing: -0.01em;
//           margin: 0;
//         }
//         .ch-subtitle {
//           margin: 8px 0 28px;
//           font-size: 14.5px;
//           color: var(--muted);
//         }

//         .ch-error {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           background: #fdf1f1;
//           border: 1px solid #f3c9c9;
//           color: var(--danger);
//           font-size: 13.5px;
//           padding: 11px 14px;
//           border-radius: 10px;
//           margin-bottom: 18px;
//         }

//         .ch-field { margin-bottom: 16px; }
//         .ch-label {
//           display: block;
//           font-size: 13px;
//           font-weight: 600;
//           margin-bottom: 7px;
//         }
//         .ch-input-wrap {
//           position: relative;
//           display: flex;
//           align-items: center;
//         }
//         .ch-input-wrap .lead {
//           position: absolute;
//           left: 14px;
//           color: var(--muted);
//           display: flex;
//           pointer-events: none;
//         }
//         .ch-input {
//           width: 100%;
//           height: 48px;
//           padding: 0 46px 0 44px;
//           font: inherit;
//           font-size: 14.5px;
//           color: var(--text);
//           background: var(--card);
//           border: 1.5px solid #dde2ea;
//           border-radius: 11px;
//           transition: border-color 0.15s, box-shadow 0.15s;
//         }
//         .ch-input::placeholder { color: #9aa4b4; }
//         .ch-input:hover { border-color: #c3cbd8; }
//         .ch-input:focus {
//           outline: none;
//           border-color: var(--accent);
//           box-shadow: 0 0 0 4px var(--accent-soft);
//         }

//         .ch-toggle {
//           position: absolute;
//           right: 8px;
//           height: 34px; width: 34px;
//           display: grid; place-items: center;
//           background: none;
//           border: none;
//           border-radius: 8px;
//           color: var(--muted);
//           cursor: pointer;
//         }
//         .ch-toggle:hover { background: #eef1f6; color: var(--text); }

//         .ch-row {
//           display: flex;
//           justify-content: flex-end;
//           margin: -4px 0 20px;
//         }
//         .ch-link {
//           font-size: 13.5px;
//           font-weight: 500;
//           color: var(--accent);
//           text-decoration: none;
//         }
//         .ch-link:hover { text-decoration: underline; }

//         .ch-submit {
//           width: 100%;
//           height: 50px;
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           gap: 10px;
//           font: inherit;
//           font-size: 15px;
//           font-weight: 600;
//           color: #fff;
//           background: var(--ink);
//           border: none;
//           border-radius: 11px;
//           cursor: pointer;
//           transition: background 0.15s, transform 0.1s;
//         }
//         .ch-submit:hover:not(:disabled) { background: #1a2742; }
//         .ch-submit:active:not(:disabled) { transform: translateY(1px); }
//         .ch-submit:disabled { opacity: 0.75; cursor: default; }
//         .ch-submit .arrow { transition: translate 0.15s; }
//         .ch-submit:hover:not(:disabled) .arrow { translate: 3px 0; }

//         .ch-spinner {
//           width: 18px; height: 18px;
//           border-radius: 50%;
//           border: 2.5px solid rgba(255, 255, 255, 0.3);
//           border-top-color: #fff;
//           animation: ch-spin 0.7s linear infinite;
//         }
//         @keyframes ch-spin { to { transform: rotate(360deg); } }

//         .ch-foot {
//           margin-top: 26px;
//           text-align: center;
//           font-size: 14px;
//           color: var(--muted);
//         }
//         .ch-foot a { font-weight: 600; }

//         :is(.ch-link, .ch-toggle, .ch-submit, .ch-foot a):focus-visible {
//           outline: 2px solid var(--accent);
//           outline-offset: 2px;
//           border-radius: 8px;
//         }

//         /* ============ responsive & motion ============ */
//         @media (max-width: 900px) {
//           .ch-root { grid-template-columns: 1fr; }
//           .ch-panel { display: none; }
//           .ch-auth { min-height: 100vh; }
//         }
//         @media (prefers-reduced-motion: reduce) {
//           .ch-card, .ch-meter i { animation: none; }
//           .ch-meter i { transform: scaleX(var(--fill, 1)); }
//           .ch-spinner { animation-duration: 1.4s; }
//         }
//       `}</style>

//       {/* ================= LEFT PANEL ================= */}
//       <aside className="ch-panel" aria-hidden="true">
//         <div className="ch-wordmark">
//           COREHire<span className="dot">.AI</span>
//         </div>

//         <h1 className="ch-headline">
//           Every resume read. Every candidate <em>ranked.</em>
//         </h1>
//         <p className="ch-sub">
//           COREHire parses, scores, and ranks applicants the moment they apply —
//           so your shortlist is ready before your first coffee.
//         </p>

//         <div className="ch-stack">
//           {CANDIDATES.map((c) => (
//             <div className="ch-card" key={c.initials}>
//               <div className="ch-avatar">{c.initials}</div>
//               <div>
//                 <div className="ch-card-name">{c.name}</div>
//                 <div className="ch-card-role">{c.role}</div>
//                 <div className="ch-tags">
//                   {c.tags.map((t) => (
//                     <span className="ch-tag" key={t}>{t}</span>
//                   ))}
//                 </div>
//               </div>
//               <div className="ch-score">
//                 <div className="ch-score-num">{c.score}</div>
//                 <div className="ch-score-label">Match</div>
//                 <div className="ch-meter">
//                   <i style={{ '--fill': c.score / 100 }} />
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="ch-panel-foot">
//           <div><strong>2× faster</strong>shortlisting</div>
//           <div><strong>AI scoring</strong>on every resume</div>
//           <div><strong>Analytics</strong>built in</div>
//         </div>
//       </aside>

//       {/* ================= AUTH SIDE ================= */}
//       <main className="ch-auth">
//         <div className="ch-auth-card">
//           <img src={logo} alt="COREHire" className="ch-logo" />
//           <h2 className="ch-title">Welcome back</h2>
//           <p className="ch-subtitle">Sign in to your hiring workspace.</p>

//           {error && (
//             <div className="ch-error" role="alert">
//               {Icon.alert}
//               <span>{error}</span>
//             </div>
//           )}

//           <form onSubmit={handleSubmit} noValidate={false}>
//             <div className="ch-field">
//               <label className="ch-label" htmlFor="ch-email">Email</label>
//               <div className="ch-input-wrap">
//                 <span className="lead">{Icon.mail}</span>
//                 <input
//                   id="ch-email"
//                   className="ch-input"
//                   type="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   placeholder="you@company.com"
//                   autoComplete="email"
//                   required
//                 />
//               </div>
//             </div>

//             <div className="ch-field">
//               <label className="ch-label" htmlFor="ch-password">Password</label>
//               <div className="ch-input-wrap">
//                 <span className="lead">{Icon.lock}</span>
//                 <input
//                   id="ch-password"
//                   className="ch-input"
//                   type={showPassword ? 'text' : 'password'}
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder="Enter your password"
//                   autoComplete="current-password"
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="ch-toggle"
//                   onClick={() => setShowPassword((s) => !s)}
//                   aria-label={showPassword ? 'Hide password' : 'Show password'}
//                 >
//                   {showPassword ? Icon.eyeOff : Icon.eye}
//                 </button>
//               </div>
//             </div>

//             <div className="ch-row">
//               <Link to="/forgotpassword" className="ch-link">Forgot password?</Link>
//             </div>

//             <button type="submit" className="ch-submit" disabled={isLoading}>
//               {isLoading ? (
//                 <span className="ch-spinner" aria-label="Signing in" />
//               ) : (
//                 <>
//                   Sign in <span className="arrow">{Icon.arrow}</span>
//                 </>
//               )}
//             </button>
//           </form>

//           <p className="ch-foot">
//             New to COREHire?{' '}
//             <Link to="/signup" className="ch-link">Create an account</Link>
//           </p>
//         </div>
//       </main>
//     </div>
//   );
// }

// export default SignIn;




//////////////

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import logo from '../assets/coreopsai.png';
import { backend_url } from '../config';

/* ------------------------------------------------------------------ */
/* Inline SVG icons — no FontAwesome dependency needed                */
/* ------------------------------------------------------------------ */
const Icon = {
  mail: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </svg>
  ),
  lock: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="4" y="11" width="16" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  ),
  eye: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  eyeOff: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 3l18 18" />
      <path d="M10.6 5.1A10.8 10.8 0 0 1 12 5c6.5 0 10 7 10 7a17.5 17.5 0 0 1-3.2 4M6.1 6.1A17 17 0 0 0 2 12s3.5 7 10 7a10.4 10.4 0 0 0 4-.8" />
      <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    </svg>
  ),
  alert: (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 9v4M12 17h.01" />
      <path d="M10.3 3.9 1.8 18.1A2 2 0 0 0 3.5 21h17a2 2 0 0 0 1.7-2.9L13.7 3.9a2 2 0 0 0-3.4 0Z" />
    </svg>
  ),
  arrow: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  ),
};

/* ------------------------------------------------------------------ */
/* Candidate stack data (left-panel visual)                           */
/* ------------------------------------------------------------------ */
const CANDIDATES = [
  { initials: 'PS', name: 'Priya Sharma', role: 'Senior Backend Engineer', score: 94, tags: ['Java', 'Spring Boot', '6 yrs'] },
  { initials: 'RK', name: 'Rahul Kapoor', role: 'Full-Stack Developer', score: 87, tags: ['React', 'Node.js', '4 yrs'] },
  { initials: 'AN', name: 'Ananya Nair', role: 'Data Engineer', score: 81, tags: ['Python', 'SQL', '5 yrs'] },
];

function SignIn({ setIsLoggedIn }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const verified = params.get('verified');
    const errorParam = params.get('error');

    if (verified === 'true') {
      setSuccess('Your email has been successfully verified! You can now sign in.');
      window.history.replaceState({}, document.title, window.location.pathname);
    } else if (verified === 'false') {
      if (errorParam === 'invalid_or_expired') {
        setError('The verification link is invalid or has expired. Please register again.');
      } else {
        setError('Email verification failed. Please try again.');
      }
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      const response = await axios.post(`${backend_url}/login`, { email, password });

      if (response.status === 200) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        setTimeout(() => {
          setIsLoggedIn(true);
          navigate('/upload');
        }, 800);
      } else {
        setError(response.data.message || 'That email and password don’t match. Try again.');
        setIsLoading(false);
      }
    } catch (err) {
      console.error('SignIn Error:', err);
      setError(err.response?.data?.message || 'That email and password don’t match. Try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className="ch-root">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Inter:wght@400;500;600&display=swap');

        /* ORIGINAL ROOT */
        .ch-root {
          --ink: #0b1220;
          --ink-2: #131f36;
          --line: rgba(255, 255, 255, 0.08);
          --paper: #f6f7f9;
          --card: #ffffff;
          --text: #172033;
          --muted: #64748b;
          --accent: #4c5fff;
          --accent-soft: rgba(76, 95, 255, 0.1);
          --match: #21c07a;
          --danger: #d84545;
          --radius: 14px;

          min-height: 100vh;
          display: grid;
          grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
          font-family: 'Inter', system-ui, sans-serif;
          background: var(--paper);
          color: var(--text);
          margin: 0;
        }

        /* ============ ORIGINAL LEFT: product panel ============ */
        .ch-panel {
          position: relative;
          background:
            radial-gradient(900px 500px at 85% -10%, rgba(76, 95, 255, 0.22), transparent 60%),
            radial-gradient(700px 600px at -10% 110%, rgba(33, 192, 122, 0.10), transparent 55%),
            var(--ink);
          color: #eef1f7;
          padding: 48px 56px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }
        .ch-panel::after {
          content: '';
          position: absolute;
          inset: 0;
          background-image: linear-gradient(var(--line) 1px, transparent 1px),
            linear-gradient(90deg, var(--line) 1px, transparent 1px);
          background-size: 56px 56px;
          mask-image: radial-gradient(700px 700px at 30% 30%, #000 0%, transparent 75%);
          pointer-events: none;
        }
        .ch-panel > * { position: relative; z-index: 1; }

        .ch-wordmark {
          font-family: 'Space Grotesk', sans-serif;
          font-weight: 700;
          font-size: 20px;
          letter-spacing: 0.02em;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .ch-wordmark .dot { color: var(--match); }

        .ch-headline {
          margin: 56px 0 0;
          font-family: 'Space Grotesk', sans-serif;
          font-size: clamp(30px, 3.2vw, 44px);
          line-height: 1.12;
          font-weight: 600;
          letter-spacing: -0.02em;
          max-width: 15ch;
        }
        .ch-headline em {
          font-style: normal;
          color: var(--match);
        }
        .ch-sub {
          margin: 18px 0 0;
          font-size: 15.5px;
          line-height: 1.6;
          color: #a6b0c3;
          max-width: 42ch;
        }

        .ch-stack {
          margin-top: 44px;
          display: grid;
          gap: 12px;
          max-width: 460px;
        }
        .ch-card {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.09);
          border-radius: 12px;
          padding: 14px 16px;
          display: grid;
          grid-template-columns: 40px 1fr auto;
          gap: 14px;
          align-items: center;
          backdrop-filter: blur(6px);
          animation: ch-rise 0.7s cubic-bezier(0.2, 0.7, 0.2, 1) both;
        }
        .ch-card:nth-child(1) { animation-delay: 0.15s; }
        .ch-card:nth-child(2) { animation-delay: 0.3s; transform-origin: left; scale: 0.985; opacity: 0.92; }
        .ch-card:nth-child(3) { animation-delay: 0.45s; scale: 0.97; opacity: 0.82; }

        .ch-avatar {
          width: 40px; height: 40px;
          border-radius: 10px;
          display: grid; place-items: center;
          font-family: 'Space Grotesk', sans-serif;
          font-weight: 600; font-size: 13px;
          background: var(--accent-soft);
          color: #9fb0ff;
          border: 1px solid rgba(76, 95, 255, 0.35);
        }
        .ch-card-name { font-weight: 600; font-size: 14px; }
        .ch-card-role { font-size: 12.5px; color: #8e99ad; margin-top: 2px; }
        .ch-tags { display: flex; gap: 6px; margin-top: 8px; flex-wrap: wrap; }
        .ch-tag {
          font-size: 10.5px;
          padding: 2px 8px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.06);
          border: 1px solid rgba(255, 255, 255, 0.1);
          color: #aeb8ca;
        }

        .ch-score { text-align: right; }
        .ch-score-num {
          font-family: 'Space Grotesk', sans-serif;
          font-weight: 700;
          font-size: 18px;
          color: var(--match);
        }
        .ch-score-label {
          font-size: 10px;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #7d8798;
        }
        .ch-meter {
          margin-top: 6px;
          width: 84px; height: 4px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.1);
          overflow: hidden;
        }
        .ch-meter i {
          display: block; height: 100%;
          border-radius: inherit;
          background: linear-gradient(90deg, var(--accent), var(--match));
          transform-origin: left;
          animation: ch-fill 1.1s 0.5s cubic-bezier(0.2, 0.7, 0.2, 1) both;
        }

        .ch-panel-foot {
          margin-top: auto;
          padding-top: 40px;
          display: flex;
          gap: 28px;
          font-size: 13px;
          color: #8e99ad;
        }
        .ch-panel-foot strong {
          display: block;
          font-family: 'Space Grotesk', sans-serif;
          font-size: 17px;
          color: #eef1f7;
          font-weight: 600;
          margin-bottom: 2px;
        }

        @keyframes ch-rise {
          from { opacity: 0; translate: 0 16px; }
          to { opacity: inherit; translate: 0 0; }
        }
        @keyframes ch-fill {
          from { transform: scaleX(0); }
          to { transform: scaleX(var(--fill, 1)); }
        }

        /* ============ NEW RIGHT: Centered auth side ============ */
        .ch-auth {
          height: 100vh;           /* Locks to exactly the window height */
          position: sticky;        /* Keeps it perfectly centered even if the left panel is taller */
          top: 0;
          display: flex;
          align-items: center;     /* Centers vertically */
          justify-content: center; /* Centers horizontally */
          padding: 24px;
          box-sizing: border-box;
        }
        
        .ch-auth-card {
          width: min(400px, 100%);
          box-sizing: border-box;
        }
        .ch-logo { height: 40px; width: auto; margin-bottom: 28px; }
        .ch-title {
          font-family: 'Space Grotesk', sans-serif;
          font-size: 26px;
          font-weight: 600;
          letter-spacing: -0.01em;
          margin: 0;
        }
        .ch-subtitle {
          margin: 8px 0 28px;
          font-size: 14.5px;
          color: var(--muted);
        }

        .ch-error {
          display: flex;
          align-items: center;
          gap: 10px;
          background: #fdf1f1;
          border: 1px solid #f3c9c9;
          color: var(--danger);
          font-size: 13.5px;
          padding: 11px 14px;
          border-radius: 10px;
          margin-bottom: 18px;
          box-sizing: border-box;
        }

        .ch-field { margin-bottom: 16px; }
        .ch-label {
          display: block;
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 7px;
        }
        .ch-input-wrap {
          position: relative;
          display: flex;
          align-items: center;
        }
        .ch-input-wrap .lead {
          position: absolute;
          left: 14px;
          color: var(--muted);
          display: flex;
          pointer-events: none;
        }
        .ch-input {
          width: 100%;
          height: 48px;
          padding: 0 46px 0 44px;
          font: inherit;
          font-size: 14.5px;
          color: var(--text);
          background: var(--card);
          border: 1.5px solid #dde2ea;
          border-radius: 11px;
          transition: border-color 0.15s, box-shadow 0.15s;
          box-sizing: border-box;
        }
        .ch-input::placeholder { color: #9aa4b4; }
        .ch-input:hover { border-color: #c3cbd8; }
        .ch-input:focus {
          outline: none;
          border-color: var(--accent);
          box-shadow: 0 0 0 4px var(--accent-soft);
        }

        .ch-toggle {
          position: absolute;
          right: 8px;
          height: 34px; width: 34px;
          display: grid; place-items: center;
          background: none;
          border: none;
          border-radius: 8px;
          color: var(--muted);
          cursor: pointer;
        }
        .ch-toggle:hover { background: #eef1f6; color: var(--text); }

        .ch-row {
          display: flex;
          justify-content: flex-end;
          margin: -4px 0 20px;
        }
        .ch-link {
          font-size: 13.5px;
          font-weight: 500;
          color: var(--accent);
          text-decoration: none;
        }
        .ch-link:hover { text-decoration: underline; }

        .ch-submit {
          width: 100%;
          height: 50px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          font: inherit;
          font-size: 15px;
          font-weight: 600;
          color: #fff;
          background: var(--ink);
          border: none;
          border-radius: 11px;
          cursor: pointer;
          transition: background 0.15s, transform 0.1s;
          box-sizing: border-box;
        }
        .ch-submit:hover:not(:disabled) { background: #1a2742; }
        .ch-submit:active:not(:disabled) { transform: translateY(1px); }
        .ch-submit:disabled { opacity: 0.75; cursor: default; }
        .ch-submit .arrow { transition: translate 0.15s; }
        .ch-submit:hover:not(:disabled) .arrow { translate: 3px 0; }

        .ch-spinner {
          width: 18px; height: 18px;
          border-radius: 50%;
          border: 2.5px solid rgba(255, 255, 255, 0.3);
          border-top-color: #fff;
          animation: ch-spin 0.7s linear infinite;
        }
        @keyframes ch-spin { to { transform: rotate(360deg); } }

        .ch-foot {
          margin-top: 26px;
          text-align: center;
          font-size: 14px;
          color: var(--muted);
        }
        .ch-foot a { font-weight: 600; }

        :is(.ch-link, .ch-toggle, .ch-submit, .ch-foot a):focus-visible {
          outline: 2px solid var(--accent);
          outline-offset: 2px;
          border-radius: 8px;
        }

        /* ============ responsive & motion ============ */
        @media (max-width: 900px) {
          .ch-root { grid-template-columns: 1fr; }
          .ch-panel { display: none; }
          .ch-auth { position: static; height: auto; min-height: 100vh; }
        }
        @media (prefers-reduced-motion: reduce) {
          .ch-card, .ch-meter i { animation: none; }
          .ch-meter i { transform: scaleX(var(--fill, 1)); }
          .ch-spinner { animation-duration: 1.4s; }
        }
      `}</style>

      {/* ================= LEFT PANEL ================= */}
      <aside className="ch-panel" aria-hidden="true">
        <div className="ch-wordmark">
          COREHire<span className="dot">.AI</span>
        </div>

        <h1 className="ch-headline">
          Every resume read. Every candidate <em>ranked.</em>
        </h1>
        <p className="ch-sub">
          COREHire parses, scores, and ranks applicants the moment they apply —
          so your shortlist is ready before your first coffee.
        </p>

        <div className="ch-stack">
          {CANDIDATES.map((c) => (
            <div className="ch-card" key={c.initials}>
              <div className="ch-avatar">{c.initials}</div>
              <div>
                <div className="ch-card-name">{c.name}</div>
                <div className="ch-card-role">{c.role}</div>
                <div className="ch-tags">
                  {c.tags.map((t) => (
                    <span className="ch-tag" key={t}>{t}</span>
                  ))}
                </div>
              </div>
              <div className="ch-score">
                <div className="ch-score-num">{c.score}</div>
                <div className="ch-score-label">Match</div>
                <div className="ch-meter">
                  <i style={{ '--fill': c.score / 100 }} />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="ch-panel-foot">
          <div><strong>2× faster</strong>shortlisting</div>
          <div><strong>AI scoring</strong>on every resume</div>
          <div><strong>Analytics</strong>built in</div>
        </div>
      </aside>

      {/* ================= AUTH SIDE ================= */}
      <main className="ch-auth">
        <div className="ch-auth-card">
          <img src={logo} alt="COREHire" className="ch-logo" />
          <h2 className="ch-title">Welcome back</h2>
          <p className="ch-subtitle">Sign in to your hiring workspace.</p>

          {error && (
            <div className="ch-error" role="alert">
              {Icon.alert}
              <span>{error}</span>
            </div>
          )}

          {success && (
            <div className="ch-error" role="alert" style={{ background: '#f0fdf4', borderColor: '#bbf7d0', color: '#15803d' }}>
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0 }}>
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              <span>{success}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate={false}>
            <div className="ch-field">
              <label className="ch-label" htmlFor="ch-email">Email</label>
              <div className="ch-input-wrap">
                <span className="lead">{Icon.mail}</span>
                <input
                  id="ch-email"
                  className="ch-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  autoComplete="email"
                  required
                />
              </div>
            </div>

            <div className="ch-field">
              <label className="ch-label" htmlFor="ch-password">Password</label>
              <div className="ch-input-wrap">
                <span className="lead">{Icon.lock}</span>
                <input
                  id="ch-password"
                  className="ch-input"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  className="ch-toggle"
                  onClick={() => setShowPassword((s) => !s)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? Icon.eyeOff : Icon.eye}
                </button>
              </div>
            </div>

            <div className="ch-row">
              <Link to="/forgotpassword" className="ch-link">Forgot password?</Link>
            </div>

            <button type="submit" className="ch-submit" disabled={isLoading}>
              {isLoading ? (
                <span className="ch-spinner" aria-label="Signing in" />
              ) : (
                <>
                  Sign in <span className="arrow">{Icon.arrow}</span>
                </>
              )}
            </button>
          </form>

          <p className="ch-foot">
            New to COREHire?{' '}
            <Link to="/signup" className="ch-link">Create an account</Link>
          </p>
        </div>
      </main>
    </div>
  );
}

export default SignIn;
